import type { OrgRole } from "./adminTypes";

export type InvitePrecheckMatch = {
  email?: string | null;
  full_name?: string | null;
  display_name?: string | null;
};

export async function invitePrecheck(params: {
  token: string;
  email: string;
  orgId: string;
}): Promise<InvitePrecheckMatch[]> {
  const precheckRes = await fetch("/api/admin/action?action=invite-precheck", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${params.token}`,
    },
    body: JSON.stringify({
      email: params.email,
      orgId: params.orgId,
    }),
  });
  const precheckJson = (await precheckRes.json()) as {
    potentialMatches?: InvitePrecheckMatch[];
    error?: string;
  };
  if (!precheckRes.ok) throw new Error(precheckJson.error || `HTTP ${precheckRes.status}`);
  return precheckJson.potentialMatches ?? [];
}

export async function sendInvite(params: {
  token: string;
  email: string;
  orgId: string;
  role: OrgRole;
  allowPotentialDuplicate: boolean;
  migrateExternalContactId: string;
}): Promise<{ migrateWarning?: string }> {
  const res = await fetch("/api/admin/action?action=invite", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${params.token}`,
    },
    body: JSON.stringify({
      email: params.email,
      orgId: params.orgId,
      role: params.role,
      allowPotentialDuplicate: params.allowPotentialDuplicate,
      migrateExternalContactId: params.migrateExternalContactId,
    }),
  });
  const json = (await res.json()) as { error?: string; migrateWarning?: string };
  if (!res.ok) throw new Error(json.error || `HTTP ${res.status}`);
  return { migrateWarning: json.migrateWarning };
}
